export default __webpack_public_path__ + "static/media/kolkatacityTakeover.dcfb42e8.png";